// This file is used to force a new build when needed
export const VERSION = '1.0.1';
export const BUILD_TIMESTAMP = new Date().toISOString();